module.exports = __webpack_public_path__ + "static/media/Raggiungimi 3.e71f28b5.png";